// Rosto de um jogador: foto enviada, avatar do elenco ou iniciais. Bots usam o avatar do nome.
import { AVATARES, avatarDoNome, imagemDoAvatar } from '@truco6/ui';
import type { Perfil } from '@truco6/mesa/protocolo';
import { conta } from './conta.ts';
import { sombraDaMoldura } from './cosmeticos.tsx';

export function srcDoRosto(perfil: Perfil | null | undefined, usuario?: string, bot = false): string | null {
  if (!perfil) return null;
  if (usuario) { const foto = conta.urlFoto(usuario, perfil.avatar); if (foto) return foto; }
  return imagemDoAvatar(perfil.avatar) ?? (bot ? imagemDoAvatar(avatarDoNome(perfil.apelido) ?? avatarDoBot(perfil.apelido)) : null);
}

// Bot sem avatar no elenco ganha um fixo, escolhido pelo nome.
function avatarDoBot(nome: string): string {
  let n = 0;
  for (const ch of nome) n = (n * 31 + ch.charCodeAt(0)) >>> 0;
  return AVATARES[n % AVATARES.length]!.id;
}

export function iniciais(nome: string): string {
  return nome.split(/\s+/).filter(Boolean).slice(0, 2).map((p) => p[0]!.toUpperCase()).join('') || '?';
}

// A coroa do Rei do Pote: o 1º da lista e o selo da semana de quem fechou em 1º. Não é cosmético da Coleção.
export function Coroa({ tamanho = 18 }: { tamanho?: number }) {
  return (
    <svg className="coroa" width={tamanho} height={tamanho} viewBox="0 0 24 24" role="img" aria-label="Coroa do Rei do Pote">
      <path d="M5 18l-1.5-10 5 3.5L12 5l3.5 6.5 5-3.5L19 18z" fill="var(--gold-400)" stroke="var(--ground-900)" strokeWidth="1.5" strokeLinejoin="round" />
    </svg>
  );
}

// moldura: o cosmético do rosto (Coleção), por fora da borda do trio. coroa: a coroa do Rei do Pote, por cima do rosto.
export function Rosto({ perfil, usuario, bot = false, cor, tamanho = 46, estilo, moldura, coroa = false }: {
  perfil: Perfil | null | undefined; usuario?: string; bot?: boolean; cor: string; tamanho?: number; estilo?: React.CSSProperties; moldura?: string;
  coroa?: boolean;
}) {
  const src = srcDoRosto(perfil, usuario, bot), nome = perfil?.apelido ?? '';
  const sombra = bot ? undefined : sombraDaMoldura(moldura);
  const rosto = (
    <div className="av" style={{ borderColor: cor, width: tamanho, height: tamanho, ...(sombra ? { boxShadow: sombra } : {}), ...estilo }}>
      {src ? <img src={src} alt={nome} /> : <span aria-label={nome}>{iniciais(nome)}</span>}
    </div>
  );
  if (!coroa || bot) return rosto;
  // A coroa fica fora do .av, que corta o que passa da borda.
  return <span className="com-coroa" style={{ width: tamanho, height: tamanho }}>{rosto}<Coroa tamanho={Math.max(16, Math.round(tamanho * 0.42))} /></span>;
}
